import $ from 'jquery';
import './expressive-annotations-validate.js';
$(function () {
  /* global ea */
  ea.settings.apply({
    enumsAsNumbers: false
  });

  // Copy validation max length attributes to input maxlength field automatically, so we only have to define this once on our model validation.
  $("input[data-val-length-max],  textarea[data-val-length-max]").each(function () {
    var $this = $(this);
    var data = $this.data();
    $this.attr("maxlength", data.valLengthMax);
  });
  $("input[data-val-maxlength-max],  textarea[data-val-maxlength-max]").each(function () {
    var $this = $(this);
    var data = $this.data();
    $this.attr("maxlength", data.valMaxlengthMax);
  });

  //trim whitespace from inputs
  $('input[type="text"]').change(function () {
    this.value = $.trim(this.value);
  });

  // blacklist form input
  $('input[type="text"], input[type="search"], input[type="number"]').bind('keypress', function (event) {
    blacklist(event);
  });
  $('input[type="text"], input[type="search"], input[type="number"]').bind('paste', function (ev) {
    var $target = $(ev.target);
    setTimeout(function () {
      var data = $target.val();
      $target.val(removeBlackListChars(data));
    });
  });
  function blacklist(event) {
    var regex = new RegExp(/^[<>[\]{}=%]+$/g);
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
  function removeBlackListChars(value) {
    return value.replace(/[<>[\]{}=%]/g, "");
  }

  // Disable form submit buttons on submit
  $("form").each(function () {
    var form = $(this);
    var validator = form.data("validator");
    if (validator) {
      validator.settings.submitHandler = function (innerform) {
        var button = $(innerform).find(":submit:not(.dont-disable)");
        if (button) {
          button.attr("disabled", true);
        }
        innerform.submit();
      };
    }
  });
});

// enable eager evaluation
$.validator.setDefaults({
  onfocusout: function onfocusout(element) {
    if (!this.checkable(element) && element.type !== "file") {
      this.element(element);
    }
  }
});